module.exports = __webpack_public_path__ + "assets/fonts/alert-diamond.82d29c4f.svg";